/**
 * ゲーム設定とパラメータ
 */

export const GAME_CONFIG = {
  // 画面サイズ
  width: 720,
  height: 1280,
  
  // セーフエリア（画面短辺の割合）
  safeAreaRatio: 0.04, // 4%
  
  // 物理パラメータ（調整可能）
  physics: {
    gravity: { x: 0, y: 2000 }, // 重力（さらに強化してスピードアップ）
    ballJumpForce: 1200, // ジャンプ力（上方向への力、強化）
    ballTapBoost: 400, // タップ時の追加速度（動いている間のタップ）
    ballBounce: 0.6, // 反発係数
    ballRadius: 40, // ボールの半径（80px画像の半分）
  },
  
  // リング設定
  ring: {
    radius: 40, // リングの半径（ボールと同じサイズ、80px画像の半分）
    thickness: 8, // リングの太さ（使用しない）
    minY: 200, // リングの最小Y位置（高い位置も許可）
    maxY: 1000, // リングの最大Y位置（広い範囲）
    sideMargin: 100, // 左右のマージン（最小値）
    glowIntensity: 0.8, // 発光の強さ（0-1）
    minDistanceFromObstacle: 150, // おじゃまキャラから最小距離（重ならないように）
  },
  
  // おじゃまキャラ設定
  obstacle: {
    radius: 40, // おじゃまキャラの半径（80px画像の半分）
    minY: 200, // おじゃまキャラの最小Y位置
    maxY: 1000, // おじゃまキャラの最大Y位置
    sideMargin: 100, // 左右のマージン（最小値）
    minDistanceFromRing: 150, // エネルギーから最小距離（重ならないように）
    minDistanceFromBall: 120, // 電球から最小距離（避けられるように）
    baseSpawnInterval: 7.0, // 基本出現間隔（秒）- より頻繁に出現
    minSpawnInterval: 1.5, // 最小出現間隔（秒）- 時間が経過してもこれ以上短くならない
    lifetime: 4.0, // おじゃまキャラの生存時間（秒）
    timeIntervalReduction: 0.08, // 1秒経過ごとに間隔を短縮する秒数（より早く短縮）
    previewDuration: 2.0, // 出現位置を事前に表示する時間（秒）
  },
  
  // バックボード設定
  backboard: {
    width: 120,
    height: 200,
    offset: 40, // リングからのオフセット
  },
  
  // 制限時間設定
  timeLimit: {
    initial: 10.0, // 初期時間（秒）
    addOnScore: 10.0, // 得点時に追加される時間（秒）
  },
  
  // スコア設定
  score: {
    base: 1, // 基本スコア
    maxComboMultiplier: 10, // 最大コンボ倍率（×10まで）
  },
  
  // エフェクト設定
  effects: {
    ballGlowDuration: 300, // ボール発光の継続時間（ミリ秒）
    darkOverlayMaxAlpha: 1.0, // 暗転オーバーレイの最大alpha
  },
  
  // 床のY位置
  floorY: 1200,
  
  // 色設定
  colors: {
    background: 0xfaf5ed, // ミッドセンチュリーモダン：温かみのあるベージュ
    backgroundTop: 0xfaf5ed, // グラデーション上部
    backgroundBottom: 0xe8dcc0, // グラデーション下部
    ball: 0xffeb3b, // 電球のような明るい黄色
    ballGlow: 0xffff99, // ボールの発光色（明るい黄色）
    ring: 0x4ecdc4,
    ringGlow: 0x00ffff,
    obstacle: 0xff0000, // おじゃまキャラの色（赤）
    backboard: 0x333333,
    text: 0x2c2c2c, // ミッドセンチュリーモダン：ダークブラウン
    darkOverlay: 0x000000,
    // ミッドセンチュリーモダンUI色
    uiBackground: 0xffffff, // UIカード背景（白）
    uiBorder: 0xd4c5b9, // UIボーダー（ベージュグレー）
    uiForeground: 0x2c2c2c, // UIテキスト（ダークブラウン）
    uiGray: 0x8b7d6b, // UIグレーテキスト（ミディアムブラウン）
    uiAccent: 0xd4af37, // マスタードイエロー
    uiSecondary: 0x4ecdc4, // ターコイズブルー
    uiPrimary: 0xff6b6b, // コーラルピンク
    gridLine: 0xe8dcc0, // グリッド線（淡いベージュ）
  },
} as const;

